// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"158f1eb1","154":"fc2396a8","731":"73bf141e","975":"565d13b6"}[chunkId] + ".chunk.css";
};